<template>
  <div class="nav-items" :class="{disabled}">
    <ul :data-active-item="activeIndex">
      <li v-for="(item, idx) in items"
          :class="[(item.classes) ? item.classes : [], {active: activeItem === item.id, 'not-interactive': !interactive}]"
          @click="select(item)">{{ item.label }}
      </li>
    </ul>

    <button type="button" class="page-nav page-prev" data-tab-to="prev" :disabled="!canNavPrev" @click="previousTab">
      <svg-icon id="chevronLeft"></svg-icon>
    </button>
    <button type="button" class="page-nav page-next" data-tab-to="next" :disabled="!canNavNext" @click="nextTab">
      <svg-icon id="chevronRight"></svg-icon>
    </button>

    <span ref="marker" class="selected"></span>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {

  props: {
    activeItem: {
      type: String,
      required: true,
    },

    interactive: {
      type: Boolean,
      default: true,
    },

    items: {
      type: Array,
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      resizeListener: null,
    }
  },

  computed: {
    activeIndex () {
      for (let x = 0; x < this.items.length; x++) {
        if (this.items[x].id === this.activeItem) {
          return x
        }
      }

      return 0
    },
    canNavNext () {
      if (this.items.length > 1) {
        return (this.activeIndex !== (this.items.length - 1))
      }

      return false
    },
    canNavPrev () {
      if (this.items.length > 1) {
        return (this.activeIndex !== 0)
      }

      return false
    },
  },

  watch: {
    'activeItem' () {
      this.updateMarker()
    }
  },

  created () {
    // Redo selector on resize
    this.resizeListener = debounce(() => {
      this.updateMarker()
      setTimeout(this.updateMarker, 350)     // Update after animations are complete
    })

    window.addEventListener('resize', this.resizeListener)
  },

  mounted () {
    this.updateMarker()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeListener)
  },

  methods: {

    selectorStyles (idx) {
      let styles = {}

      if (idx == 0) {
        styles['margin-left'] = (this.activeIndex * -100) + '%'
      }

      return styles
    },

    nextTab () {
      if (this.canNavNext) {
        this.select(this.items[this.activeIndex + 1])
      }
    },

    previousTab () {
      if (this.canNavPrev) {
        this.select(this.items[this.activeIndex - 1])
      }
    },

    select (item) {
      if (this.interactive) {
        this.$emit('select', item)
      }
    },

    updateMarker () {
      // Move our active bar
      this.$nextTick(() => {
        let selected = this.$el.querySelector('.active')

        if ((typeof selected !== 'undefined' && selected) && typeof this.$refs.marker !== 'undefined') {
          let left = Math.round(selected.offsetWidth / 2) + selected.offsetLeft + (selected.style.marginLeft ? parseInt(selected.style.marginLeft) : 0)
          this.$refs.marker.style.setProperty('left', left + 'px')
        }
      })
    },

  },

}
</script>
